import React from 'react';
import { FadeInUp } from './FadeInUp';
import { CheckCheck, ThumbsUp } from 'lucide-react';
export function SocialTrustEngine() {
  return <section className="py-20 px-6 bg-cream" data-id="element-288">
      <div className="max-w-5xl mx-auto" data-id="element-289">
        <FadeInUp data-id="element-290">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-16 text-center text-deep-green" data-id="element-291">
            Lo que dicen en sus chats privados
          </h2>
        </FadeInUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-292">
          {/* WhatsApp */}
          <FadeInUp delay={0.1} data-id="element-293">
            <div className="bg-[#E5DDD5] rounded-3xl overflow-hidden shadow-sm border border-black/5 h-full flex flex-col" data-id="element-294">
              <div className="bg-[#075E54] text-white px-4 py-3 flex items-center gap-3" data-id="element-295">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center shrink-0" data-id="element-296">
                  <span className="text-lg" data-id="element-297">💚</span>
                </div>
                <div data-id="element-298">
                  <p className="font-semibold text-sm" data-id="element-299">Grupo Bienestar 💚</p>
                  <p className="text-xs text-white/70" data-id="element-300">en línea</p>
                </div>
              </div>
              <div className="p-4 flex-grow flex flex-col justify-center" data-id="element-301">
                <div className="bg-[#DCF8C6] rounded-2xl rounded-tl-none p-3 shadow-sm relative self-start max-w-[90%]" data-id="element-302">
                  <p className="text-charcoal text-sm leading-relaxed" data-id="element-303">
                    Amigaaa empecé el lunes y ya el miércoles me sentía
                    diferente 😭🙌 Mi esposo hasta me dijo que se me ve el
                    abdomen más plano
                  </p>
                  <div className="flex items-center justify-end gap-1 mt-1" data-id="element-304">
                    <span className="text-[10px] text-charcoal/50" data-id="element-305">
                      10:42 AM
                    </span>
                    <CheckCheck className="w-3.5 h-3.5 text-[#34B7F1]" data-id="element-306" />
                  </div>
                </div>
              </div>
            </div>
          </FadeInUp>

          {/* Facebook */}
          <FadeInUp delay={0.2} data-id="element-307">
            <div className="bg-white rounded-3xl overflow-hidden shadow-sm border border-black/5 h-full flex flex-col" data-id="element-308">
              <div className="bg-[#1877F2] text-white px-4 py-3 flex items-center gap-2" data-id="element-309">
                <span className="font-bold text-lg tracking-tighter" data-id="element-310">
                  facebook
                </span>
              </div>
              <div className="p-5 flex-grow flex flex-col justify-center" data-id="element-311">
                <div className="flex gap-3" data-id="element-312">
                  <div className="w-10 h-10 bg-sage/20 text-sage rounded-full flex items-center justify-center shrink-0 font-bold" data-id="element-313">
                    LM
                  </div>
                  <div data-id="element-314">
                    <div className="bg-cream rounded-2xl p-3" data-id="element-315">
                      <p className="font-bold text-sm text-[#1877F2] mb-1" data-id="element-316">
                        Lorena M.
                      </p>
                      <p className="text-charcoal text-sm leading-relaxed" data-id="element-317">
                        Por fin algo que no cuesta $500 y que de verdad
                        funciona. Lo seguí al pie de la letra y en 5 días ya
                        dormía mejor. 100% recomendado.
                      </p>
                    </div>
                    <div className="flex items-center gap-4 mt-2 px-2" data-id="element-318">
                      <span className="text-xs text-charcoal/50 font-semibold cursor-pointer hover:underline" data-id="element-319">
                        Me gusta
                      </span>
                      <span className="text-xs text-charcoal/50 font-semibold cursor-pointer hover:underline" data-id="element-320">
                        Responder
                      </span>
                      <div className="flex items-center gap-1 text-xs text-charcoal/50" data-id="element-321">
                        <div className="bg-[#1877F2] rounded-full p-0.5" data-id="element-322">
                          <ThumbsUp className="w-2.5 h-2.5 text-white fill-current" data-id="element-323" />
                        </div>
                        12
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FadeInUp>

          {/* Instagram */}
          <FadeInUp delay={0.3} data-id="element-324">
            <div className="bg-white rounded-3xl overflow-hidden shadow-sm border border-black/5 h-full flex flex-col" data-id="element-325">
              <div className="bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F56040] text-white px-4 py-3 flex items-center justify-center" data-id="element-326">
                <p className="font-semibold text-sm" data-id="element-327">Instagram Direct</p>
              </div>
              <div className="p-4 flex-grow flex flex-col justify-center" data-id="element-328">
                <div className="bg-cream rounded-2xl rounded-tr-none p-3 shadow-sm relative self-end max-w-[90%] border border-black/5" data-id="element-329">
                  <p className="text-charcoal text-sm leading-relaxed" data-id="element-330">
                    Oye te quería decir GRACIAS 🥺 Compré la guía sin esperar
                    mucho y honestamente fue lo mejor que hice. Ya no me acuesto
                    con esa pesadez horrible.
                  </p>
                </div>
                <div className="text-right mt-1" data-id="element-331">
                  <span className="text-[10px] text-charcoal/40" data-id="element-332">
                    Visto • 2h
                  </span>
                </div>
              </div>
            </div>
          </FadeInUp>
        </div>
      </div>
    </section>;
}